import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = "https://www.crush-now.fr/api";
const STORE_URL = "https://play.google.com/store/apps/details?id=com.liabra.crushme";

const CrushPublicPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/scans/public/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error("not_found");
        return res.json();
      })
      .then(setData)
      .catch(() => setError(true));
  }, [slug]);

  const formattedDate = data?.date
    ? new Date(data.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })
    : null;

  return (
    <div style={{
      minHeight: "100svh",
      background: "#0A0A0F",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "32px 16px 48px",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}>
      {/* Logo / header */}
      <div style={{ marginBottom: "32px", textAlign: "center" }}>
        <span style={{
          fontSize: "22px", fontWeight: 900, letterSpacing: "-0.5px",
          background: "linear-gradient(135deg, #D41A6E, #E87010)",
          WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
        }}>
          CrushNow
        </span>
        <p style={{ color: "#6b7280", fontSize: "12px", margin: "4px 0 0" }}>
          Partage de crush
        </p>
      </div>

      {/* Erreur */}
      {error && (
        <div style={{ textAlign: "center", color: "#9ca3af", marginTop: "40px" }}>
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>📦</div>
          <p style={{ fontSize: "16px", fontWeight: 600, color: "#e5e7eb" }}>Lien invalide</p>
          <p style={{ fontSize: "13px", marginTop: "6px" }}>Ce crush n&apos;existe pas ou n&apos;est plus partagé.</p>
        </div>
      )}

      {/* Chargement */}
      {!data && !error && (
        <div style={{ color: "#6b7280", marginTop: "60px", fontSize: "14px" }}>Chargement...</div>
      )}

      {/* Contenu */}
      {data && (
        <div style={{
          width: "100%", maxWidth: "400px",
          background: "#141418",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 8px 40px rgba(212, 26, 110, 0.15)",
        }}>
          {/* Image produit */}
          {data.productImage ? (
            <img
              src={data.productImage}
              alt={data.productName}
              style={{
                width: "100%", height: "220px",
                objectFit: "contain",
                background: "#1c1c22",
                display: "block",
              }}
            />
          ) : (
            <div style={{
              width: "100%", height: "160px",
              background: "#1c1c22",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "56px",
            }}>
              📦
            </div>
          )}

          {/* Infos */}
          <div style={{ padding: "20px 20px 24px" }}>
            <h1 style={{
              fontSize: "20px", fontWeight: 800,
              color: "#f9fafb", margin: "0 0 6px",
              lineHeight: 1.3,
            }}>
              {data.productName}
            </h1>

            {/* Crushed par */}
            <p style={{
              fontSize: "13px", fontWeight: 600,
              background: "linear-gradient(135deg, #D41A6E, #E87010)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              margin: "0 0 16px",
            }}>
              Crushed par @{data.crushedBy}
            </p>

            {/* Détails */}
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "24px" }}>
              {data.location_label && (
                <div style={{ fontSize: "14px", color: "#d1d5db" }}>
                  🏪 {data.location_label}
                </div>
              )}
              {data.city && (
                <div style={{ fontSize: "14px", color: "#d1d5db" }}>
                  📍 {data.city}
                </div>
              )}
              {formattedDate && (
                <div style={{ fontSize: "14px", color: "#d1d5db" }}>
                  📅 {formattedDate}
                </div>
              )}
              {data.barcode && (
                <div style={{ fontSize: "11px", color: "#4b5563", fontFamily: "monospace", marginTop: "4px" }}>
                  {data.barcode}
                </div>
              )}
            </div>

            {/* Compteurs */}
            <div style={{
              display: "flex", gap: "16px", marginBottom: "24px",
              padding: "12px 16px",
              background: "#0A0A0F",
              borderRadius: "12px",
            }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#D41A6E" }}>{data.viewCount}</div>
                <div style={{ fontSize: "10px", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>vues</div>
              </div>
              <div style={{ width: "1px", background: "#1f2937" }} />
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#E87010" }}>{data.shareCount}</div>
                <div style={{ fontSize: "10px", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>partages</div>
              </div>
            </div>

            {/* CTA */}
            <a
              href={STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: "100%",
                minHeight: "48px",
                background: "linear-gradient(135deg, #D41A6E, #E87010)",
                color: "white",
                fontSize: "15px", fontWeight: 700,
                borderRadius: "24px",
                border: "none",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              Telecharger CrushNow
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrushPublicPage;
